import {
	comMapping
} from '../../../../util/Function/comMapping.js'
export function getdata() {
	var obj = {
		searchlist: [{
				prop: "companyCode",
				label: '公司代码',
				type: "input"
			},
			{
				prop: "suosq",
				label: '所属期',
				type: "datemonth",
				valueformat: 'yyyyMM'
			},
			{
				prop: "fapdm",
				label: '发票代码',
				type: "input"
			},
			{
				prop: "faphm",
				label: '发票号码',
				type: "input",
			},
			{
				prop: "sdfaphm",
				label: '数电票号码',
				type: "input",
			},
			{
				prop: "kaiprq",
				label: '开票日期',
				type: "datemonth",
				valueformat: 'yyyy-MM-dd'
			},
			{
				prop: "faplx",
				label: '发票类型',
				type: "select",
				selectval: comMapping.$fplx
			},
			{
				label: "处理状态",
				prop: "businessMatchStatus",
				type: "select",
				selectval:[
					{
						value:'0',
						label:'未匹配'
					},{
						value:'1',
						label:'匹配成功'
					},{
						value:'2',
						label:'暂不处理'
					}
				]
			},

		],
		searchdata: {
			companyCode: '',
			shenbq: '',
			fapdm: '',
			other: '',
			faphm: '',
			sdfaphm: '',
			businessType: '',
			kaiprq: [],
			containtotal: '',
			nottotal: '',
			setotal: '',
			choptin: '',
			chtime: '',
			businessMatchStatus:''
		},
		headData: [{
				title: "公司代码",
				prop: "companyCode",
				width: 80,
				custom:true
			},
			{
				title: "所属期",
				prop: "suosq",
				width: 80,
				custom:true
			},
			{
				title: "发票代码",
				prop: "fapdm",
				width: 80,custom:true
			},
			{
				title: "发票号码",
				prop: "faphm",
				width: 80,custom:true
			},
			{
				title: "数电票号码",
				prop: "sdfaphm",
				width: 130,custom:true
			},
			{
				title: "业务类型",
				prop: "businessType",
				custom: true,
				width: 80,
			},
			{
				prop: "businessMatchStatus",
				title: '处理状态',
				width: 80,
				custom:true
			},
			{
				title: "开票日期",
				prop: "kaiprq",
				width: 80,custom:true
			},
			{
				title: "发票类型",
				prop: "faplx",
				custom: true,
				width: 80,
			},
			{
				title: "含税金额合计",
				prop: "hansjehj",
				width: 110,
				AmountFormat: true,
				custom:true
			},
			{
				title: "未税金额合计",
				prop: "weisjehj",
				width: 110,
				AmountFormat: true,
				custom:true
			}, {
				title: "税额合计",
				prop: "shuiehj",
				width: 80,
				AmountFormat: true,
				custom:true
			}, {
				title: "作废标记",
				prop: "zuofbz",
				custom: true,
				width: 80,
			}, {
				title: "作废日期",
				prop: "zuofrq",
				width: 80,custom:true
			}, {
				title: "标志",
				prop: "biaoz",
				width: 80,custom:true
			}, {
				title: "批次号",
				prop: "pich",
				width: 80,
				custom:true
			},

		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		syncFormDefault: {
			issueDate: '',
			invoiceType: '',
			invoiceStatus: '',
			issueStart: '',
			issueEnd: ''
		}
	}
	return obj
}
